export default "__VITE_ASSET__Bih09esZ__"